var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.ref,staticClass:"fx_Bmap_container"},[_c('div',{staticClass:"fx_Bmap_top"},[_vm._t("default")],2),_c('div',{style:({'height':`${_vm.chartHeight}`,'flex':1})},[_c('div',{ref:_vm.chartRef,staticClass:"fx_Bmap"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }